export function matchesAlias(url: string, alias: string): boolean {
  const toRegExp = (part: string) =>
    new RegExp(`^${part.split('*').map((chunk) => chunk.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*')}$`)

  return alias.split(/\s+/).filter(Boolean).some((part) => toRegExp(part).test(url))
}